module.exports = __webpack_public_path__ + "img/mob2.cf6da2ff.png";